import { createApi } from "@reduxjs/toolkit/query/react";

import apiBaseQuery from "./axiosBaseQuery";

export const COMPANY_API_REDUCER_KEY = "companyApi";

export const companyApi = createApi({
  reducerPath: COMPANY_API_REDUCER_KEY,
  baseQuery: apiBaseQuery,
  tagTypes: ["company"],
  endpoints: (builder) => ({
    getCompanyList: builder.query({
      query: () => ({
        url: "/admin/companies/",
      }),
      providesTags: ["company"],
    }),

    getCompany: builder.query({
      query: (id) => ({
        url: `/admin/companies/${id}`,
      }),
      providesTags: ["company"],
    }),

    createCompany: builder.mutation({
      query: (body) => {
        return {
          url: "/admin/companies/",
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["company"],
    }),

    updateCompany: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: `/admin/companies/${id}/`,
        method: "PUT",
        body: rest,
      }),
      invalidatesTags: ["company"],
    }),

    deleteCompany: builder.mutation({
      query: (id) => ({
        url: `/admin/companies/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["company"],
    }),

    getCompanySiteList: builder.query({
      query: () => ({
        url: "/admin/companies/company-sites/",
      }),
      providesTags: ["company"],
    }),
    getCompanySite: builder.query({
      query: (id) => ({
        url: `/admin/companies/company-sites/${id}`,
      }),
      providesTags: ["company"],
    }),

    createCompanySite: builder.mutation({
      query: (body) => {
        return {
          url: "/admin/companies/company-sites/",
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["company"],
    }),

    updateCompanySite: builder.mutation({
      query: ({ id, ...rest }) => {
        return {
          url: `/admin/companies/company-sites/${id}/`,
          method: "PUT",
          body: rest,
        };
      },
      invalidatesTags: ["company"],
    }),

    deleteCompanySite: builder.mutation({
      query: (id) => {
        return {
          url: `/admin/companies/company-sites/${id}/`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["company"],
    }),
    generateReport: builder.mutation({
      query: (body) => {
        return {
          url: `/companies/report_template/post/`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["company"],
    }),
    updateReport: builder.mutation({
      query: ({ id, ...rest }) => {
        return {
          url: `/companies/report_template/${id}/`,
          method: "PATCH",
          body: rest,
        };
      },
      invalidatesTags: ["company"],
    }),
    deleteReport: builder.mutation({
      query: (id) => {
        return {
          url: `/companies/report_template/${id}/`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["company"],
    }),
    getReports: builder.query({
      query: () => {
        return {
          url: `/companies/report_template/?limit=30`,
        };
      },
      providesTags: ["company"],
    }),
    getSingleReport: builder.query({
      query: (id) => {
        return {
          url: `/companies/report_template/${id}/`,
        };
      },
      providesTags: ["company"],
    }),
  }),
});

export const {
  useGetCompanyListQuery,
  useGetCompanySiteListQuery,
  useGetCompanySiteQuery,
  useCreateCompanyMutation,
  useCreateCompanySiteMutation,
  useUpdateCompanySiteMutation,
  useDeleteCompanySiteMutation,
  useGetCompanyQuery,
  useDeleteCompanyMutation,
  useUpdateCompanyMutation,
  useGenerateReportMutation,
  useGetReportsQuery,
  useGetSingleReportQuery,
  useDeleteReportMutation,
  useUpdateReportMutation,
} = companyApi;
